import {
  SpeakerVoiceActionTypes,
  IFetchSpeakerVoicesPayload,
  IFetchSpeakerVoicesSuccessResponseBody,
  IFetchLanguagesSuccessResponseBody,
  IUpdateSpeakerVoicePayload,
  IUpdateSpeakerVoiceSuccessResponseBody,
  IRemoveSpeakerVoicesFromWorkspacePayload,
  IRemoveSpeakerVoicesFromWorkspaceSuccessResponseBody,
  ICreateSpeakerVoicePayload,
  ICreateSpeakerVoiceSuccessResponseBody,
  IGenerateDesignSamplePayload,
  IGenerateDesignSampleSuccessResponseBody,
  IGenerateDesignSampleFailurePayload,
  IChangeSelectedSpeakerVoicesPayload,
  ISetSearchTermPayload,
  ISetOpenedSpeakerVoiceIdPayload,
  ISetIsNewSpeakerVoicePayload,
  IChangeSelectedLanguageNamePayload,
  ISetSelectedLanguagesNamesPayload,
} from './types'

export const fetchSpeakerVoices = (payload: IFetchSpeakerVoicesPayload) => ({
  type: SpeakerVoiceActionTypes.FETCH_SPEAKER_VOICES,
  payload,
})

export const fetchSpeakerVoicesSuccess = (payload: IFetchSpeakerVoicesSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.FETCH_SPEAKER_VOICES_SUCCESS,
  payload,
})

export const fetchSpeakerVoicesFailure = () => ({
  type: SpeakerVoiceActionTypes.FETCH_SPEAKER_VOICES_FAILURE,
})

export const fetchLanguages = () => ({
  type: SpeakerVoiceActionTypes.FETCH_LANGUAGES,
})

export const fetchLanguagesSuccess = (payload: IFetchLanguagesSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.FETCH_LANGUAGES_SUCCESS,
  payload,
})

export const fetchLanguagesFailure = () => ({
  type: SpeakerVoiceActionTypes.FETCH_LANGUAGES_FAILURE,
})

export const resetShouldCheckAutoFill = () => ({
  type: SpeakerVoiceActionTypes.RESET_SHOULD_CHECK_AUTO_FILL,
})

export const setShouldCheckAutoFill = () => ({
  type: SpeakerVoiceActionTypes.SET_SHOULD_CHECK_AUTO_FILL,
})

export const updateSpeakerVoice = (payload: IUpdateSpeakerVoicePayload) => ({
  type: SpeakerVoiceActionTypes.UPDATE_SPEAKER_VOICE,
  payload,
})

export const updateSpeakerVoiceSuccess = (payload: IUpdateSpeakerVoiceSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.UPDATE_SPEAKER_VOICE_SUCCESS,
  payload,
})

export const updateSpeakerVoiceFailure = () => ({
  type: SpeakerVoiceActionTypes.UPDATE_SPEAKER_VOICE_FAILURE,
})

export const removeSpeakerVoicesFromWorkspace = (payload: IRemoveSpeakerVoicesFromWorkspacePayload) => ({
  type: SpeakerVoiceActionTypes.REMOVE_SPEAKER_VOICES_FROM_WORKSPACE,
  payload,
})

export const removeSpeakerVoicesFromWorkspaceSuccess = (payload: IRemoveSpeakerVoicesFromWorkspaceSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.REMOVE_SPEAKER_VOICES_FROM_WORKSPACE_SUCCESS,
  payload,
})

export const removeSpeakerVoicesFromWorkspaceFailure = () => ({
  type: SpeakerVoiceActionTypes.REMOVE_SPEAKER_VOICES_FROM_WORKSPACE_FAILURE,
})

export const createSpeakerVoice = (payload: ICreateSpeakerVoicePayload) => ({
  type: SpeakerVoiceActionTypes.CREATE_SPEAKER_VOICE,
  payload,
})

export const createSpeakerVoiceSuccess = (payload: ICreateSpeakerVoiceSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.CREATE_SPEAKER_VOICE_SUCCESS,
  payload,
})

export const createSpeakerVoiceFailure = () => ({
  type: SpeakerVoiceActionTypes.CREATE_SPEAKER_VOICE_FAILURE,
})

export const generateDesignSample = (payload: IGenerateDesignSamplePayload) => ({
  type: SpeakerVoiceActionTypes.GENERATE_DESIGN_SAMPLE,
  payload,
})

export const generateDesignSampleSuccess = (payload: IGenerateDesignSampleSuccessResponseBody) => ({
  type: SpeakerVoiceActionTypes.GENERATE_DESIGN_SAMPLE_SUCCESS,
  payload,
})

export const generateDesignSampleFailure = (payload: IGenerateDesignSampleFailurePayload) => ({
  type: SpeakerVoiceActionTypes.GENERATE_DESIGN_SAMPLE_FAILURE,
  payload,
})

export const resetGeneratedDesignSample = () => ({
  type: SpeakerVoiceActionTypes.RESET_GENERATED_DESIGN_SAMPLE,
})

export const changeSelectedSpeakerVoices = (payload: IChangeSelectedSpeakerVoicesPayload) => ({
  type: SpeakerVoiceActionTypes.CHANGE_SELECTED_SPEAKER_VOICES,
  payload,
})

export const resetSelectedSpeakerVoices = () => ({
  type: SpeakerVoiceActionTypes.RESET_SELECTED_SPEAKER_VOICES,
})

export const setSearchTerm = (payload: ISetSearchTermPayload) => ({
  type: SpeakerVoiceActionTypes.SET_SEARCH_TERM,
  payload,
})

export const setOpenedSpeakerVoiceId = (payload: ISetOpenedSpeakerVoiceIdPayload) => ({
  type: SpeakerVoiceActionTypes.SET_OPENED_SPEAKER_VOICE_ID,
  payload,
})

export const resetOpenedSpeakerVoiceId = () => ({
  type: SpeakerVoiceActionTypes.RESET_OPENED_SPEAKER_VOICE_ID,
})

export const setIsNewSpeakerVoice = (payload: ISetIsNewSpeakerVoicePayload) => ({
  type: SpeakerVoiceActionTypes.SET_IS_NEW_SPEAKER_VOICE,
  payload,
})

export const resetIsNewSpeakerVoice = () => ({
  type: SpeakerVoiceActionTypes.RESET_IS_NEW_SPEAKER_VOICE,
})

export const changeSelectedLanguageName = (payload: IChangeSelectedLanguageNamePayload) => ({
  type: SpeakerVoiceActionTypes.CHANGE_SELECTED_LANGUAGE,
  payload,
})

export const setSelectedLanguagesNames = (payload: ISetSelectedLanguagesNamesPayload) => ({
  type: SpeakerVoiceActionTypes.SET_SELECTED_LANGUAGES,
  payload,
})
